/**
 * MY — Share Certificate (M32205) Register Detail 매핑.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32205', {
  title: 'Share Certificate Details',
  fields: [
    { label: 'Company Name', key: ['entityName', 'companyName', 'company_name', 'presetForm.companyName', 'presetForm.state.values.company_name'] },
    { label: 'Registration No.', key: ['entityRegNo', 'companyRegistrationNo', 'presetForm.companyRegistrationNo', 'presetForm.state.values.company_registration_no'] },
    { label: 'Certificate No.', key: ['presetForm.certNo', 'presetForm.state.values.cert_no', 'cert_no'] },
    { label: 'Registered Holder', key: ['presetForm.memberName', 'presetForm.state.values.member_name', 'member_name'] },
    { label: 'No. of Shares', key: ['presetForm.state.values.no_of_shares', 'no_of_shares'] },
    { label: 'Class of Shares', key: ['presetForm.state.values.share_class', 'share_class'] },
    { label: 'Issue Date', key: ['presetForm.issueDate', 'presetForm.state.values.issue_date', 'issue_date'] },
  ],
});
